export enum ImageStateEnum {
	Default = 'default',
	Hover = 'hover',
	Pressed = 'pressed',
	Disabled = 'disabled'
}
